import React, { useState, useEffect } from "react";
import axios from "axios";
import TicketModal from "./TicketModal";
import EscalationModal from "./EscalationModal";
import UpdateStatusModal from "./UpdateStatusModal";
import ResolutionModal from "./ResolutionModal";

const testURL = process.env.REACT_APP_TEST_URL;
const productionURL = process.env.REACT_APP_PRODUCTION_URL;
const TicketTable = ({ selectedFilter }) => {
  const [tickets, setTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEscalationOpen, setEscalationOpen] = useState(false);
  const [isUpdateStatusOpen, setUpdateStatusOpen] = useState(false);
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [isResolutionOpen, setResolutionOpen] = useState(false);
  const [resolutionData, setResolutionData] = useState(null);
  const [isStatusModalOpen, setStatusModalOpen] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  useEffect(() => {
    axios.get(productionURL + "/api/ondc/getIssueDetails")
      .then((response) => {
        setTickets(response.data.ondcIssueDetails);
      })
      .catch((error) => {
        console.error("Error fetching tickets:", error);
      });
  }, []);

  const handleRowClick = async (ticketId) => {
    try {
      const response = await axios.get(testURL + `/api/ondc/getIssue/${ticketId}`);
      setSelectedTicket(response.data);
      setModalOpen(true);
    } catch (error) {
      console.error("Error fetching ticket details:", error);
    }
  };

  const handleStatusChange = async (event, ticketId) => {
    const selectedStatus = event.target.value;

    if (selectedStatus === "Escalated") {
      setSelectedTicketId(ticketId);
      setEscalationOpen(true);
    } else if (selectedStatus === "Update Status to Buyer") {
      setSelectedTicketId(ticketId);
      setUpdateStatusOpen(true);
    } else if (selectedStatus === "Get Resolution") {
      try {
        const response = await axios.get(productionURL + `/api/ondc/getResolution/${ticketId}`);
        if (Array.isArray(response.data) && response.data.length > 0) {
          setResolutionData(response.data);
          setResolutionOpen(true);
        } else {
          console.error("No resolution data found");
          setResolutionData([]);
        }
      } catch (error) {
        console.error("Error fetching resolution details:", error);
      }
    } else if (selectedStatus === "Check Status") {
      try {
        const response = await axios.post(productionURL + `/api/ondc/issueStatus/${ticketId}`);
        setStatusMessage(response.data); // Store API response
        setStatusModalOpen(true);
      } catch (error) {
        console.error("Error fetching status:", error);
        setStatusMessage("Failed to retrieve status.");
        setStatusModalOpen(true);
      }
    }
  };

  const filteredTickets = selectedFilter === "ALL" ? tickets : tickets.filter(ticket => ticket.status === selectedFilter);

  return (
    <div className="table-container">
      <h3>Tickets</h3>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Ticket ID</th>
            <th>Category</th>
            <th>Short Description</th>
            <th>Status</th>
            <th>Created At</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredTickets.map((ticket) => (
            <tr key={ticket.id} onClick={() => handleRowClick(ticket.ticketId)}>
              <td>{ticket.id}</td>
              <td>{ticket.ticketId}</td>
              <td>{ticket.category}</td>
              <td>{ticket.shortDesc}</td>
              <td className={`status-badge ${ticket.status ? ticket.status.toLowerCase() : ''}`}>
                {ticket.status || "N/A"}
              </td>
              <td>{new Date(ticket.createdAt).toLocaleString()}</td>
              <td>
                <select onClick={(e) => e.stopPropagation()} onChange={(e) => handleStatusChange(e, ticket.ticketId)}>
                  <option value="">Select Action</option>
                  <option value="Issue Resolved by Buyer">Issue Resolved by Buyer</option>
                  <option value="Escalated">Escalated</option>
                  <option value="Update Status to Buyer">Update Status to Buyer</option>
                  <option value="Get Resolution">Get Resolution</option>
                  <option value="Check Status">Check Status</option> {/* New Option */}
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Ticket Details Modal */}
      {isModalOpen && selectedTicket && (
        <TicketModal ticket={selectedTicket} onClose={() => setModalOpen(false)} />
      )}

      {/* Escalation Modal */}
      {isEscalationOpen && (
        <EscalationModal isOpen={isEscalationOpen} onClose={() => setEscalationOpen(false)} issueId={selectedTicketId} />
      )}

      {/* Update Status Modal */}
      {isUpdateStatusOpen && selectedTicketId && (
        <UpdateStatusModal
          isOpen={isUpdateStatusOpen}
          onClose={() => setUpdateStatusOpen(false)}
          ticketId={selectedTicketId}
        />
      )}

      {/* Resolution Modal */}
      {isResolutionOpen && resolutionData && (
        <ResolutionModal data={resolutionData} onClose={() => setResolutionOpen(false)} />
      )}

      {/* Status Modal */}
      {isStatusModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h4>Current Status</h4>
            <p>{statusMessage}</p>
            <button onClick={() => setStatusModalOpen(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TicketTable;
